import { PageHeader, Button, Modal ,Row, Col , Form , Space , Select } from 'antd'
import React, { useState , useEffect } from 'react'
import JcpReceiptList from '../../components/enrollment/jcp/JcpReceiptList'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import RegistrationList from '../../components/registration/RegistrationList'
import { PlusOutlined, PrinterOutlined, FileExcelOutlined } from "@ant-design/icons";
import { ALL_MEMBER_PDF_URL, ALL_MEMBER_XLS_URL, STUDENT_IDS_PRINT_URL } from '../../utility/URL'
import memberService from '../../api/member.service'
import commonUtility from '../../utility/Utils'
const { Option } = Select;

const Registrationlist = () => {

  const [form] = Form.useForm();


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [memberList, setMemberList] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };


  const onAccountSave = async (values) => {
    console.log('selectedMembers',selectedMembers);
    const commaSeparatedString = selectedMembers.join(',');
    // console.log(commaSeparatedString);
    commonUtility.openInNewTab(STUDENT_IDS_PRINT_URL+"/"+commaSeparatedString);
  }

  useEffect(() => {
    memberService.allMemberListPersonalInfo().then((res) => {
      setMemberList(res.data.response_data)
    });
  }, [])

  return (




    <div>


      <div className="inside-main-content">
        <AdminBreadCrumb />

        <div className="box-style">
          <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="Registration List"
            subTitle=""
            extra={[
              <Button key="MemberPDFDownloadButtonX" className="custom-button-white" shape="round" size="medium" onClick={() => showModal()}>
                Member ID Print
              </Button>,

              <Button key="MemberPDFDownloadButtonY" className="custom-button-white" shape="round" size="medium" onClick={() => commonUtility.openInNewTab(ALL_MEMBER_PDF_URL)}>
                <PrinterOutlined /> PDF
              </Button>,

              <Button key="MemberXLSDownloadButtonZ" className="custom-button-white" shape="round" size="medium" onClick={() => commonUtility.openInNewTab(ALL_MEMBER_XLS_URL)}>
                <FileExcelOutlined /> Excel
              </Button>,

            ]}

          ></PageHeader>


          <div className='tableView'>
            <div className="form-content">
              <RegistrationList />
            </div>
          </div>

          <Modal 
          title="Student/Member Selection" 
          visible={isModalOpen} onOk={handleOk} 
          onCancel={handleCancel} 
          footer={null}
          style={{ top: 20 }} // Adjust the top position as needed
          bodyStyle={{ maxHeight: '70vh', overflowY: 'auto' }}
          >
            <div className="form-input-style">

              <Row className="" style={{ background: "transparent" }}>
                <Col className="" xs={24} xl={24}>
                  <Form
                    form={form}
                    layout="vertical"
                    onFinish={onAccountSave}
                    autoComplete="off"
                    //initialValues={formDefaultValues}
                  >


                    <Row gutter={20}>


                      <Col xs={24} xl={24}>
                        <Form.Item name="member_id" label="Student/Member List" rules={[
                          {
                            required: true,
                            message: 'Select Member/Trainer',
                          },
                        ]}>
                          <Select
                            className="text-left"
                            showSearch
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children.toString().toLowerCase().includes(input.toLowerCase())
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children.toString().toLowerCase().localeCompare(optionB.children.toString().toLowerCase())
                            }
                            placement="bottomLeft"
                            allowClear={true}
                            mode="multiple" // Enable multiple selection
                            onChange={setSelectedMembers} // Store selected values in state
                          >

                            {
                              memberList.length > 0 ?
                              memberList.map(member_list => (
                                  <Option key={member_list.member_id} value={member_list.member_id}>
                                   {`${member_list.member_fname} ${member_list.member_lname
                                    } | ${member_list.primary_mobile}`}
                                    </Option>

                                ))
                                : ''
                            }
                          </Select>
                        </Form.Item>
                      </Col>



                      <Col xs={24} xl={24} align="right">
                        <Form.Item name="" label=" ">
                          <Space>



                            <Button className="custom-button-green" htmlType="submit">
                              Print
                            </Button>
                          </Space>
                        </Form.Item>
                      </Col>


                    </Row>
                  </Form>



                </Col>
              </Row>



            </div>

          </Modal>


        </div>
      </div>

    </div>







  )
}

export default Registrationlist